import { CloseButton as RBCloseButton } from "react-bootstrap";

const CloseButton = ({ onClick , ...props}) => {
  return (
    <RBCloseButton onClick={onClick} {...props} />
  );
};

export default CloseButton;